<template>
  <b-row align-h="center" align-v="end" v-if="loading" class="vh-50">
    <b-col>
      <pulse-loader
        class="text-center"
        color="#290A99"
      />
      <h6 class="text-center">Cargando dashboard</h6>
    </b-col>
  </b-row>
  <div v-else>
    <b-row align-h="center" align-v="center" v-if="sellout.loading" class="vh-50">
      <b-col>
        <pulse-loader
          class="text-center"
          color="#290A99"
        />
        <h6 class="text-center">Cargando sellout</h6>
      </b-col>
    </b-row>
    <SelloutCard
      v-else
      @open-filters="showModalFilters = true"
      :sales-growth-indicators="desktopDashboardData.salesGrowthDashboardIndicators"
      :sell-out-chart="desktopDashboardData.sellOutChart"
      :store-growth="desktopDashboardData.storeGrowth"
      @change-metric="updateDesktopData"
      @change-dashboard-indicator="changeDashboardIndicator"
      @change-sellout-dimension="changeSelloutDimension"
    />
    <KpiCardStrip
      :wm-product-count="desktopDashboardData.wmProductCount"
      :stock-break-count="desktopDashboardData.stockBreakCount"
      :news-feed-indicators="desktopDashboardData.newsFeedIndicators"
    />
    <TheSalesAnalysisModalFilters
      v-model="showModalFilters"
      title="Filtros para el modulo de sales análisis"
      :selected-store-filters="selectedStoreFilters"
      :selected-product-filters="selectedProductFilters"
      @save-filters="applyFilters"
    />
  </div>
</template>

<script>
  import SelloutCard from '../components/Dashboard/SelloutCard'
  import KpiCardStrip from '../components/Dashboard/KpiCardStrip'
  import TheSalesAnalysisModalFilters from '@/app/shared/components/TheModalFilters'
  import { Types as TypesSalesAnalysis } from '@/app/sales_analysis/store/Index'
  import { baseMetrics } from '@/expertoRetail/library/commonParameters'
  import { metricOptions, filterOptions, chartMetricOptions } from '@/expertoRetail/atoms/AccumulatedSales/Common/baseParameters'
  import { sales } from '@/services/api/ExpertoRetail'

  export default {
    name: 'TheDashboardView',
    components: {
      SelloutCard,
      KpiCardStrip,
      TheSalesAnalysisModalFilters
    },
    data () {
      return {
        loading: null,
        showModalFilters: false,
        desktopDashboardData: {
          salesGrowthDashboardIndicators: null,
          sellOutChart: null,
          storeGrowth: null,
          wmProductCount: null,
          stockBreakCount: null,
        },
        sellout: {
          loading: false
        }
      }
    },
    async created () {
      await this.getDesktopData()
      // this.$eventHub.$emit('dashboard-is-ready', {})
    },
    beforeDestroy () {
      this.$store.commit('commit_accumulatedSales_resetState')
    },
    computed: {
      selectedFilters () {
        return this.$store.state.salesAnalysis.filters
      },
      selectedStoreFilters () {
        return this.selectedFilters.selectedStoreFilters
      },
      selectedProductFilters () {
        return this.selectedFilters.selectedProductFilters
      },
      dashboardFactTable () {
        return this.$store.state.accumulatedSales.factTable
      },
      selloutDimensions () {
        return this.$store.state.accumulatedSales.selectedDimension.card1
      }
    },
    methods: {
      applyFilters (filters) {
        this.$store.dispatch(TypesSalesAnalysis.actions.APPLY_FILTERS, filters)
        this.showModalFilters = false
        this.getDesktopData(this.$store.state.metric)
      },
      buildSalesGrowthDashboardIndicatorsParams (metric) {
        return {
          parameters: {
            product_filters: this.selectedProductFilters,
            store_filters: this.selectedStoreFilters,
            metrics: {
              normal: baseMetrics[metric].normal,
              var: baseMetrics[metric].var
            }
          }
        }
      },
      buildSellOutByDimensionParams (metric) {
        const parameters = {
          product_filters: this.selectedProductFilters,
          store_filters: this.selectedStoreFilters,
          limit: 20,
          offset: 0,
          fact:  {
            type: 'table',
            name: this.dashboardFactTable
          },
          metrics: {
            normal: chartMetricOptions[metric]
          },
          sort:{
            field: chartMetricOptions[metric][0],
            dir: 'DESC'
          }, ...this.selloutDimensions
        }
        return {
            parameters
          }
      },
      buildStoreGrowthCountParams (metric) {
        return {
          parameters: {
            product_filters: this.selectedProductFilters,
            store_filters: this.selectedStoreFilters,
            limit: 50,
            offset: 0,
            fact:  {
              type: 'table',
              name: this.dashboardFactTable
            },
            store_dimensions: ['retail_store_name', 'store_id', 'retail_name', 'gmap_coordinate'],
            metrics: {
              normal: metricOptions[metric].normal,
              var: metricOptions[metric].var
            },
            sort:{
              field: metricOptions[metric].normal[4],
              dir: 'DESC'
            },
            having_filters: filterOptions[metric]
          }
        }
      },
      buildWmProductCount () {
        return {
          parameters: {
            store_filters: {
              store_type_id: [1, 3]
            },
            metrics: {
              normal: ['product_count'],
              var: []
            },
            fact: {
              type: 'table',
              name: 'dw_product_wm'
            },
            limit: 0,
            offset: 0
          }
        }
      },
      buildStockBreakCount () {
        return {
          parameters: {
            store_filters: {
              store_type_id: [1, 3]
            },
            metrics: {
              normal: ['stock_break_status'],
              var: []
            },
            fact: {
              type: 'table',
              name: 'dw_suggested_all'
            },
            sort: {
              field: 'stock_break_status',
              dir: 'DESC'
            },
            metric_filters: ['stock_break_status = 1', 'week_avg > 1 '],
            limit: 0,
            offset: 0
          }
        }
      },
      buildDesktopDashboardParameters (metric) {
        return {
          sales_growth_dashboard_indicators_params: this.buildSalesGrowthDashboardIndicatorsParams(metric),
          sell_out_by_dimension_params: this.buildSellOutByDimensionParams(metric),
          store_growth_count_params: this.buildStoreGrowthCountParams(metric),
          wm_product_count: this.buildWmProductCount(),
          stock_break_count: this.buildStockBreakCount(),
        }
      },
      async getDesktopData () {
        this.loading = true
        const metric = this.$store.state.metric
        const payload = this.buildDesktopDashboardParameters(metric)
        this.desktopDashboardData = await sales.desktopDashboard(payload)
        this.loading = false
      } ,
      updateDesktopData () {
        this.getDesktopData()
      },
      changeDashboardIndicator () {
        this.getDesktopData()
      },
      async changeSelloutDimension (dimensions) {
        this.sellout.loading = true
        const metric = this.$store.state.metric
        this.$store.commit('commit_selectedDimension', [dimensions, 'card1'])
        const parameters = this.buildSellOutByDimensionParams(metric)
        this.desktopDashboardData.sellOutChart = await sales.salesTwoRanges(parameters)
        this.sellout.loading = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/views/Dashboard.vue